import logoBlack from "assets/vylor-logo-black.svg";
import logoWhite from "assets/vylor-logo-white.svg";
import styles from "./VylorLogo.module.scss";

interface VylorLogoProps {
  alt: string;
  className?: string;
  id?: string;
}

/**
 * The Vylor wordmark, with black text in the light theme and white text in the
 * dark theme. Both images are rendered and CSS hides the one that does not
 * match, so the logo follows the in-app theme setting and not only the OS.
 */
export default function VylorLogo({ alt, className, id }: VylorLogoProps) {
  return (
    <span
      role="img"
      aria-label={alt}
      id={id}
      className={`${styles.logo} ${className ?? ""}`}
    >
      <img src={logoBlack} alt="" className={styles.black} />
      <img src={logoWhite} alt="" className={styles.white} />
    </span>
  );
}
